import { Component } from '@angular/core';
import { ErrorService, Errormessage } from '@app/services/error.service';

@Component({
  selector: 'app-errormessage',
  templateUrl: './errormessage.component.html',
  styleUrls: ['./errormessage.component.css']
})
export class ErrormessageComponent {
  edited = false;
  errormsg: Errormessage;

  constructor(private errorService: ErrorService) {
    this.errorService.error.subscribe(err => { if (err) { this.showTodos(err); } });
  }

  showTodos(err: Errormessage): void {
    this.edited = true;
    this.errormsg = err;
  }

  closeErrorMsg() {
    this.edited = false;
    this.errorService.error.next(null);
  }
}
